import { Component, DestroyRef, OnInit, inject, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { combineLatest, filter, take } from 'rxjs';
import { environment } from '../../../environments/environment';
import { isDeployedSite } from '../../data/deploy-host';
import { AppHeaderComponent } from '../../components/app-header/app-header.component';
import { NavBarComponent } from '../../components/nav-bar/nav-bar.component';
import { FundingModalComponent } from '../../components/funding-modal/funding-modal.component';
import { CpuTeamModalComponent } from '../../components/cpu-team-modal/cpu-team-modal.component';
import { DirectChallengeModalComponent } from '../../components/direct-challenge-modal/direct-challenge-modal.component';
import { TeamSelectComponent } from '../../components/team-select/team-select.component';
import { DailyChallengeCardComponent } from '../../components/daily-challenge-card/daily-challenge-card.component';
import { LobbyFeedComponent } from '../../components/lobby-feed/lobby-feed.component';
import { QueueListingsStripComponent } from '../../components/queue-listings-strip/queue-listings-strip.component';
import { BattleActionsComponent } from '../../components/battle-actions/battle-actions.component';
import { GachaCtaStripComponent } from '../../components/gacha-cta-strip/gacha-cta-strip.component';
import { PartyBuilderModalComponent } from '../../components/party-builder-modal/party-builder-modal.component';
import { PartyInviteCardComponent } from '../../components/party-invite-card/party-invite-card.component';
import { RecentBattlesComponent } from '../../components/recent-battles/recent-battles.component';
import { OnlinePlayersSidebarComponent } from '../../components/online-players-sidebar/online-players-sidebar.component';
import { OnlinePlayersSheetComponent } from '../../components/online-players-sheet/online-players-sheet.component';
import { PlaySheetComponent } from '../../components/play-sheet/play-sheet.component';
import { ProfilePreviewCardComponent } from '../../components/profile-preview-card/profile-preview-card.component';
import { MobileScaleService } from '../../services/mobile-scale.service';
import { Wallet } from '../../services/wallet';
import { ServerService } from '../../services/server.service';
import { LobbyController } from '../../services/lobby-controller';
import { FrensTicketPayload } from '../../types/server';

@Component({
  selector: 'app-home',
  imports: [
    AppHeaderComponent,
    NavBarComponent,
    FundingModalComponent,
    CpuTeamModalComponent,
    DirectChallengeModalComponent,
    PartyBuilderModalComponent,
    PartyInviteCardComponent,
    TeamSelectComponent,
    DailyChallengeCardComponent,
    LobbyFeedComponent,
    QueueListingsStripComponent,
    BattleActionsComponent,
    GachaCtaStripComponent,
    RecentBattlesComponent,
    OnlinePlayersSidebarComponent,
    OnlinePlayersSheetComponent,
    PlaySheetComponent,
    ProfilePreviewCardComponent,
  ],
  providers: [LobbyController],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css', './home.component.mobile.css'],
})
export class HomeComponent implements OnInit {
  wallet = inject(Wallet);
  server = inject(ServerService);
  mobile = inject(MobileScaleService);
  lobby = inject(LobbyController);
  private route = inject(ActivatedRoute);
  private readonly destroyRef = inject(DestroyRef);

  cpuModalOpen = signal(false);
  playSheetOpen = signal(false);
  partyBuilderOpen = signal(false);

  ngOnInit() {
    if (this.route.snapshot.data?.['frens'] && environment.network === 'mainnet' && isDeployedSite()) {
      // Wallet-connect and the drip ticket arrive independently; gate on both.
      combineLatest([
        this.wallet.walletConnectedEvent.pipe(filter((connected) => connected === true)),
        this.server.frensTicket$.pipe(filter((t): t is FrensTicketPayload => !!t)),
      ])
        .pipe(take(1), takeUntilDestroyed(this.destroyRef))
        .subscribe(([, frens]) => {
          if (this.wallet.gameAccountBalance() === 0n) {
            this.wallet.askFrensFaucet(frens).catch((err) =>
              console.error('frens faucet failed', err),
            );
          }
        });
    }
  }
}
